import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import EN from './locales/en'
import FR from './locales/fr'

let SITE_LOCALE
function checkLocale(local) {
  switch (local) {
    case 'fr':
    case 'en':
      return local
    default:
      return null
  }
}
function extractLocal() {
  const searchParams = new URLSearchParams(window.location.search)
  if (searchParams.has('locale')) {
    const result = checkLocale(searchParams.get('locale'))
    if (result) {
      return result
    }
  }

  const pathname = new URL(window.location.href).pathname
  const locale = pathname.split('/').reduce((accum, curr) => {
    if (accum) {
      return accum
    }
    const locale = checkLocale(curr)
    if (locale !== null) {
      return locale
    }
    return false
  }, null)
  return locale || 'en'
}
export function getLocal() {
  if (SITE_LOCALE) {
    return SITE_LOCALE
  }
  SITE_LOCALE = extractLocal()

  return SITE_LOCALE
}

export const config = {
  debug: false,
  fallbackLng: getLocal(),
  interpolation: {
    escapeValue: false,
  },
  resources: {
    en: {
      translation: EN,
    },
    fr: {
      translation: FR,
    },
  },
}

i18n.use(initReactI18next).init(config)

export default i18n
